import type { RentalManagerAuthCheckUserInfoWebApiDto } from '@zg-rentals/ts-rental-manager-api-client';
import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { createAuthPredicates } from '@zg-rentals/auth-comet/mfa';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { rentalManagerClient } from './rentalManagerClient';

export type User = RentalManagerAuthCheckUserInfoWebApiDto;

export const { hasInitiatedAuth, hasAuth } = createAuthPredicates((user: User) => ({
  ...user,
  isLoggedIn: user.loggedIn,
}));

export const Auth = defineAuthProvider({
  queryOptions: () => RentalManagerUserInfoV2WebApiHandler_get_queryOptions({}, { httpClient: rentalManagerClient }),
  isAuthorized: hasInitiatedAuth,
});

export const { useAuth } = Auth;
